import makeGlobalStateHook from 'messaging-management-lib/data/makeGlobalStateHook';
import { useMemo } from 'react';
let useEmailCustomPropertiesState = makeGlobalStateHook();
export default function useEmailCloneCustomPropertiesState() {
  const [shouldCloneCustomProperties, setShouldCloneCustomProperties] = useEmailCustomPropertiesState(true);
  return useMemo(() => ({
    shouldCloneCustomProperties,
    setShouldCloneCustomProperties
  }), [shouldCloneCustomProperties, setShouldCloneCustomProperties]);
}

// This is for use within tests
export function resetEmailCloneCustomPropertiesState() {
  useEmailCustomPropertiesState = makeGlobalStateHook();
}